import { useMediaQuery } from '@wp-g2/utils';

function MediaQuery(_ref) {
  var children = _ref.children,
      media = _ref.media;
  var match = useMediaQuery(media);
  if (!media || !match) return null;
  return children;
}

export default MediaQuery;